export const classifyAuthFailureReason = (status, payload = {}) => {
  const message = String(payload?.message || payload?.error || "").toLowerCase();

  if (status === 401 || status === 403) {
    return "session-expired";
  }

  if (status === 404 && message.includes("account not found")) {
    return "deleted-account";
  }

  if (status === 404 && message.includes("user not found")) {
    return "deleted-account";
  }

  return "unknown";
};
